import { render } from "./static-page-list.vue?vue&type=template&id=53e101d2"
import script from "./static-page-list.vue?vue&type=script&lang=js"
export * from "./static-page-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__